import { Component } from '@angular/core';

/** Botão flutuante "voltar" (canto inferior esquerdo). O clique é tratado pelo pai via `(click)`. */
@Component({
  selector: 'app-back-button',
  imports: [],
  templateUrl: './back-button.html',
  styleUrl: './back-button.scss',
})
export class BackButton {}
